import { render, staticRenderFns } from "./captionsProperty.vue?vue&type=template&id=20ef0496"
import script from "./captionsProperty.vue?vue&type=script&lang=js"
export * from "./captionsProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports